<template>
  <div class="product">
    <div class="title c-muli-bold">{{ $t("productList") }}</div>
    <div class="gallery">
      <div
        :class="['arrow arrow_prev', { disabled: state.activeIndex === 0 }]"
        @click="onClickArrow('prev')"
      >
        <c-icon name="arrow_left" />
      </div>
      <div
        :class="[
          'arrow arrow_next',
          { disabled: state.activeIndex === state.products.length - 1 },
        ]"
        @click="onClickArrow('next')"
      >
        <c-icon name="arrow_right" />
      </div>
      <Swiper
        :slidesPerView="'auto'"
        centerInsufficientSlides
        :allowTouchMove="false"
        :speed="0"
        @swiper="onSwiper"
      >
        <SwiperSlide
          :class="{
            active: state.activeIndex === index,
            done: Boolean(state.products[index].isComment),
          }"
          v-for="(item, index) in state.products"
          :key="index"
          @click="onSlideClick(index)"
        >
          <c-popover
            :show="state.activeIndex === index"
            transition=""
            class="name-popover"
            :offset="[0, 24]"
          >
            <template #reference>
              <img :src="item.skuDetail.imageSrc" alt="" />
              <c-icon name="success_full" />
            </template>
            <div
              v-show="state.activeIndex === index"
              class="name c-muli-semibold"
            >
              {{ item.skuDetail.title }}
              ({{ item.skuDetail.localSize }})
              <div class="tri"></div>
            </div>
          </c-popover>
        </SwiperSlide>
      </Swiper>
    </div>
    <div class="gallery-m">
      <c-icon
        :class="[
          'm-arrow',
          'arrow_left',
          { disabled: state.activeIndex === 0 },
        ]"
        name="arrow_left"
        @click="onClickArrowM('prev')"
      />
      <c-icon
        :class="[
          'm-arrow',
          'arrow_right',
          { disabled: state.activeIndex === state.products.length - 1 },
        ]"
        name="arrow_right"
        @click="onClickArrowM('next')"
      />
      <Swiper
        @swiper="onSwiperM"
        @activeIndexChange="onSlideChangeM"
        :slidesPerView="3"
        :centeredSlides="true"
        :allowTouchMove="false"
      >
        <SwiperSlide
          :class="{
            active: state.activeIndex === index,
            done: Boolean(state.products[index].isComment),
          }"
          v-for="(item, index) in state.products"
          :key="index"
          @click="onSlideClickM(index)"
        >
          <img :src="item.skuDetail.imageSrc" alt="" />
          <c-icon
            name="success_full"
            color="#00B45A"
            style="background-color: #fff; border-radius: 50%"
          />
        </SwiperSlide>
        <div
          v-if="state.products[state.activeIndex]"
          class="name c-muli-semibold"
        >
          {{ state.products[state.activeIndex].skuDetail.title }}({{
            state.products[state.activeIndex].skuDetail.localSize
          }})
        </div>
      </Swiper>
    </div>
    <ProductForm
      :item="activeItem"
      :active-index="state.activeIndex"
      :loading="state.loading"
      @comment="onComment"
      @next="onNext"
    />
  </div>
</template>

<script setup>
import { reactive, ref, computed, onMounted, inject } from "vue";
import { useRoute, useRouter } from "vue-router";
// import { Toast } from "cupshe-element";
import { useI18n } from "vue-i18n";
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import ProductForm from "../components/product-form.vue";
import { getOrderReviews, postProductComment } from "../service";

SwiperCore.use([Navigation]);
const app = inject("app");
const swiperRef = ref(null);
const swiperRefM = ref(null);

const router = useRouter();
const route = useRoute();
const { t } = useI18n();

const { orderId, siteId, brandId, channelId, terminalId, account } =
  route.query;

const state = reactive({
  activeIndex: 0,
  products: [],
  // 订单信息，从url参数中接口获取
  review: null,
  loading: false,
  reward: false,
});

onMounted(() => {
  getOrderCustomer();
});

const getOrderCustomer = () => {
  const param = {
    orderId,
    siteId,
    brandId,
    channelId,
    terminalId,
    account,
    lang: t("lang"),
    langCode: t("langCode"),
  };

  getOrderReviews(param).then((res) => {
    res.data.data.orderId = orderId;
    state.review = res.data.data;
    state.products = res.data.data.products;
    if (localStorage.getItem("skip-product-check") === "1") {
      localStorage.removeItem("skip-product-check");
    } else {
      checkIsAllProductsCommented(state.products);
    }
  });
};

const checkIsAllProductsCommented = (products) => {
  if (products.every((i) => i.isComment === 1)) {
    router.push({ path: "/productsuccess", query: route.query });
  }
};

const onSwiper = (value) => {
  swiperRef.value = value;
};

const onSwiperM = (value) => {
  swiperRefM.value = value;
};

const onSlideChangeM = (value) => {
  state.activeIndex = value.activeIndex;
};

const onSlideClick = (index) => {
  const slidesPerView = Math.min(5, state.products.length);
  state.activeIndex = index;
  if (state.activeIndex < slidesPerView - 1) {
    swiperRef.value.slidePrev();
  } else {
    swiperRef.value.slideNext();
  }
};

const onSlideClickM = (index) => {
  swiperRefM.value.slideTo(index);
};

const onClickArrow = (action) => {
  const slidesPerView = Math.min(5, state.products.length);
  if (action === "prev") {
    if (state.activeIndex === 0) return;
    state.activeIndex -= 1;
    if (state.activeIndex <= slidesPerView - 1) {
      swiperRef.value.slidePrev();
    }
  } else {
    if (state.activeIndex < state.products.length - 1) {
      state.activeIndex += 1;
    }
    if (state.activeIndex >= slidesPerView - 1) {
      swiperRef.value.slideNext();
    }
  }
};

const onClickArrowM = (action) => {
  if (action === "prev") {
    if (state.activeIndex === 0) return;
    swiperRefM.value.slidePrev();
  } else {
    if (state.activeIndex === state.products.length - 1) return;
    swiperRefM.value.slideNext();
  }
};

const activeItem = computed(() => {
  return state.products[state.activeIndex];
});

const onComment = (index, param, fileList) => {
  const { productReview, ...rest } = param;

  const formData = new FormData();

  fileList.forEach((file) => {
    formData.append("files", file.file);
  });

  for (let i in rest) {
    formData.append(i, rest[i]);
  }

  const params = {
    account: state.review.account,
    email: state.review.email,
    userId: state.review.customerId,
    customerId: state.review.customerId,
    activityName: t("activityName"),
    lang: t("lang"),
    langCode: t("langCode"),
    siteId,
    brandId,
    terminalId,
    channelId,
    orderId: state.review.orderId,
  };

  for (let i in params) {
    formData.append(i, params[i]);
  }

  state.loading = true;
  postProductComment(formData)
    .then((res) => {
      state.loading = false;
      state.products[index].isComment = 1;
      state.products[index].productReview = productReview;
      state.products[index].fileList = fileList;
      console.log(res.data.data);
      if (res.data.data.grant) {
        app.reward = true;
        // Toast.success(t("RewardsToast"));
      }
      checkIsAllProductsCommented(state.products);
    })
    .catch(() => {
      state.loading = false;
    });
};

const onNext = () => {
  onClickArrowM("next");
  window.scrollTo({ top: 0, behavior: "smooth" });
};
</script>

<style lang="less" scoped>
@import "../../node_modules/swiper/swiper.min.css";
@import "../../node_modules/swiper/components/pagination/pagination.min.css";

@media (max-width: 768px) {
  .product {
    .title {
      font-size: 18px;
      line-height: 23px;
      letter-spacing: 1px;
      text-transform: uppercase;
      text-align: center;
      margin-top: 40px;
      color: #333;
    }
  }
}

@media (min-width: 769px) {
  .product {
    color: #333;
    .title {
      font-size: 30px;
      line-height: 38px;
      letter-spacing: 2px;
      text-transform: uppercase;
      text-align: center;
      margin-top: 50px;
    }
  }
}

.gallery {
  position: relative;
  width: 660px;
  margin: 48px auto 77px;

  .arrow {
    position: absolute;
    width: 40px;
    height: 40px;
    border: 1px solid #d3d3d3;
    border-radius: 50%;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    color: #333;
    top: 85px;

    &.arrow_prev {
      left: -70px;
    }

    &.arrow_next {
      right: -68px;
    }

    &.disabled {
      cursor: default;
      color: #999;
    }
  }

  .swiper-wrapper {
    align-items: flex-end;
  }

  .swiper-slide {
    position: relative;
    text-align: center;
    font-size: 18px;
    background: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: flex-start;
    justify-content: flex-start;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: flex-end;
    width: 132px;
    height: 192px;
    opacity: 0.3;
    cursor: pointer;
    transform: scale(5/6);
    transform-origin: bottom;

    &.active {
      opacity: 1;
      transform: scale(1);
    }

    .c-icon {
      position: absolute;
      font-size: 24px;
      top: 0;
      display: none;
      right: 0;
    }

    &.done {
      .c-icon {
        display: block;
      }
    }

    img {
      display: block;
      width: 120px;
      height: 180px;
      object-fit: cover;
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
}

.gallery-m {
  width: calc(100vw - 80px);
  margin: 20px auto;
  position: relative;

  .m-arrow {
    position: absolute;
    font-size: 24px;
    color: #333;
    top: 50%;
    transform: translateY(-100%);

    &.arrow_left {
      left: -24px;
    }

    &.arrow_right {
      right: -24px;
    }

    &.disabled {
      color: #999;
    }
  }
  .swiper {
    width: 260px;
    padding-top: 50px;
    padding-bottom: 50px;
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
    background-position: center;
    background-size: cover;
    width: 100px;
    height: 174px;
    opacity: 0.3;
    transform: scale(0.64);
    transition: all 0.3s;

    &.active {
      opacity: 1;
      transform: unset;
    }

    .c-icon {
      position: absolute;
      font-size: 24px;
      top: 0;
      left: 50%;
      transform: translateX(36px);
      display: none;
    }

    &.done {
      .c-icon {
        display: block;
      }
    }

    img {
      display: block;
      height: 150px;
      object-fit: cover;
      transform: translateY(12px);
    }
  }

  .name {
    text-align: center;
    max-width: 100%;
    font-size: 12px;
    line-height: 15px;
    color: #333;
  }

  @media (min-width: 769px) {
    display: none;
  }
}
</style>
<style lang="less">
.name-popover {
  .c-popover__arrow {
    display: none;
  }

  .c-popover__content {
    box-shadow: unset;
    background: transparent;
    overflow: unset;

    .name {
      position: relative;
      font-size: 12px;
      line-height: 15px;
      color: #333;

      .tri {
        position: absolute;
        width: 0;
        height: 0;
        top: 31px;
        left: 50%;
        transform: translateX(-50%);
        border-left: 13px solid transparent;
        border-right: 13px solid transparent;
        border-bottom: 22px solid #fafafa;
      }
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
}
</style>
